import { render, staticRenderFns } from "./Tap.vue?vue&type=template&id=77b3856e&scoped=true&"
import script from "./Tap.vue?vue&type=script&lang=js&"
export * from "./Tap.vue?vue&type=script&lang=js&"
import style0 from "./Tap.vue?vue&type=style&index=0&id=77b3856e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b3856e",
  null
  
)

export default component.exports